<template>
	<div class="row">
		<div class="col-sm-4">
			<div class="form-check form-switch">
				<input
					class="form-check-input"
					v-model="filter.enabled"
					type="checkbox"
					id="filterCheck"
				/>
				<label class="form-check-label text-yellow" for="filterCheck"
					>Advance Filters (View all leads or apply filters)</label
				>
			</div>
		</div>
	</div>
	<Transition>
		<div v-if="filter.enabled" class="row px-4 my-4 filter-row">
			<div class="col-sm-2">
				<BaseInput
					name="DateFrom"
					label="Date From"
					type="date"
					v-model="filter.fromDate"
					class="form-control form-control-lg dashInput"
				/>
			</div>
			<div class="col-sm-2">
				<BaseInput
					name="DateTo"
					label="Date To"
					type="date"
					v-model="filter.toDate"
					class="form-control form-control-lg dashInput"
				/>
			</div>
			<div class="form-group col-sm-2 mb-4">
				<BaseMultiSelect
					@update:value="setLeadPriority"
					:options="multiSelectState.leadPriority"
					name="Lead Priority"
				/>
			</div>
			<div class="form-group col-sm-2 mb-4">
				<BaseMultiSelect
					@update:value="setLeadStatus"
					:options="multiSelectState.leadStatus"
					name="Lead Status"
				/>
			</div>
			<div v-if="!removeFilter.user" class="form-group col-sm-2 mb-4">
				<BaseMultiSelect
					@update:value="setAssignedTo"
					:options="multiSelectState.usersSelect"
					:defaultData="filter.assignedTo"
					name="Assigned To"
				/>
			</div>
			<div class="form-group col-sm-2 mb-4">
				<BaseMultiSelect
					@update:value="setEnquiryType"
					:options="multiSelectState.enquiryType"
					name="Enquiry Type"
				/>
			</div>
			<div class="col-sm-2">
				<BaseInput
					name="leadNumber"
					label="Lead Number"
					type="text"
					v-model="filter.leadNumber"
					class="form-control form-control-lg dashInput"
				/>
			</div>
			<div class="col-sm-2">
				<BaseInput
					name="firstName"
					label="First Name"
					type="text"
					v-model="filter.firstName"
					class="form-control form-control-lg dashInput"
				/>
			</div>
			<div class="col-sm-2">
				<BaseInput
					name="lastName"
					label="Last Name"
					type="text"
					v-model="filter.lastName"
					class="form-control form-control-lg dashInput"
				/>
			</div>
			<div class="col-sm-2">
				<BaseInput
					name="mobileNumber"
					label="Mobile Number"
					type="number"
					:min="6999999999"
					:max="9999999999"
					v-model="filter.mobileNumber"
					class="form-control form-control-lg dashInput"
				/>
			</div>
			<div class="col-sm-2">
				<BaseInput
					name="emailId"
					label="Email Id"
					type="email"
					v-model="filter.emailId"
					class="form-control form-control-lg dashInput"
				/>
			</div>
			<div class="form-group col-sm-2 mb-4">
				<BaseMultiSelect
					@update:value="setTags"
					:options="multiSelectState.tagsSelect"
					name="Tags"
				/>
			</div>
			<div class="form-group col-sm-2 mb-4">
				<BaseMultiSelect
					@update:value="setLimit"
					:options="multiSelectState.limitSelect"
					:defaultData="multiSelectState.limit"
					name="Result Limit"
				/>
			</div>
			<div class="form-group col-sm-2 mt-2 d-flex align-items-center">
				<BaseButton
					class="btn form-control btn-primary"
					type="submit"
					label="Search"
					@on:Click="setFilterQuery"
					:loading="formState.isLoading"
				/>
			</div>
		</div>
	</Transition>
	<div class="row px-4 table-wrapper">
		<table-lite
			:is-loading="table.isLoading"
			:columns="table.columns"
			:rows="table.rows"
			:total="table.totalRecordCount"
			:sortable="table.sortable"
			:messages="table.messages"
			@do-search="doSearch"
			@is-finished="tableLoadingFinish"
			:pageOptions="[ { value: 10, text: 10 }, { value: 25, text: 25 }, { value: 50, text: 50 }, { value: 100, text: 100 }, { value: 500, text: 500 }, { value: 1000, text: 1000 } ]"
		/>

		<div
			:class="`modal fade ${model.active ? 'show' : ''}`"
			id="staticBackdrop"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="staticBackdropLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title" id="staticBackdropLabel">Add a note</h6>
						<button
							type="button"
							class="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
							@click="modelEvent('close')"
						></button>
					</div>
					<div class="modal-body">
						<BaseTextArea v-model="model.note" name="Add Note" />
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-primary"
							@click="modelEvent('save')"
						>
							Save
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- <div
			:class="`modal fade ${model.active ? 'show' : ''}`"
			id="staticBackdropNew"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="staticBackdropLabelNew"
			aria-hidden="true"
		>
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title" id="staticBackdropLabelNew">Add a note</h6>
						<button
							type="button"
							class="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
							@click="toggleModel()"
						></button>
					</div>
				</div>
			</div>
		</div> -->
	</div>
</template>
<script>
	import { inject, reactive, onMounted, computed, onBeforeUnmount } from "vue";
	import { useRouter } from "vue-router";
	import toast from "@/config/toast";
	import API from "@/config/api";
	import TableLite from "vue3-table-lite";
	import BaseTextArea from "./BaseTextArea.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseInput from "./BaseInput.vue";
	import BaseButton from "./BaseButton.vue";

	import Data from "@/helpers/dataHelper";



	export default {
		name: "LeadTable",
		props: {
			slug: { type:String, default: "" },
		},
		components: {
			TableLite,
			BaseTextArea,
			BaseMultiSelect,
			BaseInput,
			BaseButton,
		},
		setup: (props) => {

			
			const store = inject("store");
			const masterStore = inject("masterStore");
			const router = useRouter();


			const roles = reactive({
				env_admin: process.env.VUE_APP_USER_ADMIN,
			});

			if (!store.state.auth.isAuth) router.push({ name: "Login" });
			const model = reactive({
				active: false,
				note: null,
				id: null,
			});

			const table = reactive({
				isLoading: false,
				columns: [
					{
						label: "Lead No.",
						field: "leadNumber",
						width: "6%",
						sortable: false,
						display: function (row) {
							return `<b>${row.leadNumber}</b>`;
						},
					},
					{
						label: "Contact Name",
						width: "12%",
						field: "",
						sortable: false,
						display: function (row) {
							return `<span class="is-rows-el ">
							${row.name.salutation}
							${row.name.firstName}
							${row.name.lastName}
							</span>`;
						},
					},
					{
						label: "Phone",
						field: "phone",
						width: "6%",
						sortable: false,
					},
					{
						label: "Lead Source",
						field: "leadSource",
						width: "6%",
						sortable: false,
					},
					{
						label: "Lead Status",
						field: "leadStatus",
						width: "11%",
						sortable: false,
						display: function (row) {
							let newClass = "-";
							if (row.leadStatus === "New" && row?.isWebsite) {
								newClass = "btn-info text-light flash-status";
							}
							else if (row.leadStatus === "New") {
								newClass = "btn-info text-light";
							} else if (row.leadStatus === "Unqualified") {
								newClass = "gray-color text-light";
							} else if (row.leadStatus === "Working") {
								newClass = "bg-green text-light";
							} else if (row.leadStatus === "Booked") {
								newClass = "green-color text-light";
							} else if (row.leadStatus === "Lost") {
								newClass = "orange-color text-light";
							} else if (row.leadStatus === "Proposal Sent") {
								newClass = "green-color text-light";
							}else if(row.leadStatus== "Negotiating") {
								newClass = "green-color text-light";
							}
							return `<span class="is-rows-el p-1 w-100 d-flex justify-content-center align-items-center ${newClass} custom-rounded">
							${row.leadStatus === 'New' && row?.isWebsite ? 'New - Website' : row.leadStatus === 'Working' ? `${row.leadStatus} -${row.leadSubStatus}` : row.leadStatus  }
							</span>`;
						},
					},
					{
						label: "Assigned To",
						field: "",
						width: "8%",
						sortable: false,
						display: function (row) {
							let name = "-";
							if (row.assignedTo instanceof Object) {
								name = `${row.assignedTo.firstName}
							${row.assignedTo.lastName}`;
							}
							return `<span class="is-rows-el ">
							${name}
							</span>`;
						},
					},
					{
						label: "Current User",
						field: "",
						width: "8%",
						sortable: false,
						display: function (row) {
							let name = "-";
							if (row.currentUser instanceof Object) {
								name = `${row.currentUser.firstName}
							${row.currentUser.lastName}`;
							} else name = `${row?.assignedTo?.firstName || '-'}
							${row?.assignedTo?.lastName || ''}`;
							return `<span class="is-rows-el "  >
							${name}
							</span>`;
						},
					},
					{
						label: "Destination",
						field: "",
						width: "4%",
						sortable: false,
						display: function (row) {
							let destination = row.package?.itinerary && row.package?.itinerary.length
								? row.package.itinerary[row.package.itinerary.length - 1].city.name
								: row?.placeToVisit ? row.placeToVisit :'-';
							return `<span  class="is-rows-el quick">${destination}</span>`;
						},
					},
					{
						label: "Trip Type",
						field: "tripType",
						width: "8%",
						sortable: false,
					},
					{
						label: "Tags",
						field: "",
						width: "6%",
						sortable: false,
						display: function (row) {
							let string = "";
							row?.tags.map(
								(tag) =>
									(string = `${string} <span  class="is-rows-el quick"> ${tag.name}</span><br>`),
							);
							return `<div>${string}</div>`;
						},
					},
					{
						label: "Tour Start",
						field: "",
						width: "6%",
						sortable: false,
						display: function (row) {
							return `<span  class="is-rows-el quick">${
								row.package?.startDate || row.flightBooking.length
									? new Intl.DateTimeFormat("en-US", {
											timeZone: "Asia/Kolkata",
											dateStyle: "medium",
											timeStyle: "short",
									  })
											.format(
												new Date(
													row.package?.startDate ||
														row?.flightBooking[0].departureDate,
												) - new Date(18000000 + 1800000),
											)
											.toString()
											.replace(/([,]\s[1][2][:][0][0])\s\w+/g, "")
									: "-"
							}</span>`;
						},
					},
					{
						label: "Tour End",
						field: "",
						width: "6%",
						sortable: false,
						display: function (row) {
							let duration = row.package?.itinerary
								? row.package.itinerary.length - 1
								: 0;
							if (!duration) return `<span> - </span>`;
							duration = 60 * 60 * 24 * 1000 * duration;
							let endDate = new Date(
								new Date(row.package.startDate).getTime() + duration,
							);

							return `<span  class="is-rows-el quick">${
								row.package?.startDate
									? new Intl.DateTimeFormat("en-US", {
											timeZone: "Asia/Kolkata",
											dateStyle: "medium",
											timeStyle: "short",
									  })
											.format(new Date(endDate) - new Date(18000000 + 1800000))
											.toString()
											.replace(/([,]\s[1][2][:][0][0])\s\w+/g, "")
									: "-"
							}</span>`;
						},
					},
					{
						label: "Created",
						field: "",
						width: "5%",
						sortable: true,
						display: function (row) {
							return `<span class="is-rows-el quick">${new Intl.DateTimeFormat(
								"en-US",
								{
									timeZone: "Asia/Kolkata",
									dateStyle: "medium",
									timeStyle: "short",
								},
							).format(
								new Date(row.createdAt) - new Date(18000000 + 1800000),
							)}</span>`;
						},
					},
					{
						label: "Actions",
						field: "",
						width: "15%",
						sortable: false,
						display: function (row) {
							// <button type="button" data-id="${row._id}"
							//        data-action="show" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="top" data-bs-content="Send proposal on whatsapp"
							//        class="is-rows-el action-btn btn btn-sm btn-success"><i class="bi bi-eye"></i> Show Lead</button>
							let btnView = `<div  data-id="${row._id}"
	                               data-action="show" 	
	                               class="is-rows-el action-btn my-1 text-dark "><i class="bi bi-eye"></i> Show Lead</div>`;
							let btnEdit = `<div data-id="${row._id}"
	                                data-action="edit" 
	                               class="is-rows-el action-btn my-1  text-dark ">
	                               <i class="bi bi-pencil-square"></i> Edit Lead
	                               </div>`;
							let btnDelete = `<div data-id="${row._id}"
	                                data-action="delete"
	                               class="is-rows-el action-btn my-1 text-dark "><i class="bi bi-trash"></i> Delete Lead</div>`;
							let btnEmail = `<div data-id="${row._id}" 
	                                data-action="email"
	                               class="is-rows-el action-btn my-1 bg-primary"><i class="bi bi-envelope"></i> Send proposal email</div>`;
							let btnDownloadProposal = `<div data-id="${row._id}" 
	                                data-action="preview-email"
	                               class="is-rows-el action-btn my-1 bg-primary"><i class="bi bi-eye"></i> Preview proposal </div>`;
							let btnWhatsApp = `<div data-id="${row._id}" 
							data-action="whatsapp"
							class="is-rows-el action-btn my-1 bg-info"><i class="bi bi-whatsapp"></i> Send proposal on whatsapp</div>`;

							let btnNote = `<div data-id=${row._id}  data-action="note" class="is-rows-el action-btn my-1 text-dark "> <i class="bi bi-card-text"></i> Add Note</div>`;

							let btnCashReceipt = `
							<div data-id=${row._id} data-action="receipt" class="is-rows-el action-btn my-1 bg-warning"> <i class="bi bi-receipt"></i> Add payment receipt</div>
							`;
							let btnDownloadReceipt = `
							<div data-id=${row._id} data-action="preview-receipt" class="is-rows-el action-btn my-1 bg-warning"> <i class="bi bi-eye"></i> Preview payment receipt</div>
							`;

							let btnSendCashReceipt = `
							<div data-id=${row._id}  data-action="send-receipt" class="is-rows-el action-btn my-1 bg-success"> <i class="bi bi-receipt-cutoff"></i> Send receipt</div>
							`;

							return `<div class="d-flex justify-content-center align-items-center position-relative action-container">
										<div class="action-dot"></div> 
										<div class="actions">
											${
												(
													(row.leadStatus === "Working" &&
													row.leadSubStatus === "Ops") || row.leadStatus === "Proposal Sent" || row.leadStatus === "Negotiating" || row.leadStatus === "Booked")  && row.package?.itinerary && row.package?.itinerary.length
													? btnDownloadProposal
													: ""
											}
											${
												(
													(row.leadStatus === "Working" &&
													row.leadSubStatus === "Ops") || row.leadStatus === "Proposal Sent" || row.leadStatus === "Negotiating" || row.leadStatus === "Booked")  && row.package?.itinerary &&  row.package?.itinerary.length
													? btnEmail
													: ""
											}
											${
												(
													(row.leadStatus === "Working" &&
													row.leadSubStatus === "Ops") || row.leadStatus === "Proposal Sent" || row.leadStatus === "Negotiating" || row.leadStatus === "Booked")  && row.package?.itinerary &&  row.package?.itinerary.length && row?.whatsappOptIn
													? btnWhatsApp
													: ""
											}
											${
												row?.payments && row.payments.length ? btnDownloadReceipt : ""
											}
											${
												row.leadStatus === "Booked" ? btnCashReceipt : ""
											}
											${
												 row?.payments && row.payments.length && row.payments[0].verified ? btnSendCashReceipt : ""
											}
											${btnNote}${btnView}${btnEdit}${
								store.state.user.role[0] === "SALES_EXECUTIVE" ? "" : btnDelete
							}
										</div>
								</div>`;
						},
					},
				],
				rows: [],
				totalRecordCount: 10,
				sortable: {
					sort: "desc",
				},
			});

			const filter = reactive({
				enabled: false,
				fromDate: null,
				toDate: null,
				leadPriority: null,
				leadStatus: null,
				leadSubStatus: null,
				assignedTo: null,
				enquiryType: null,
				leadNumber: null,
				firstName: null,
				lastName: null,
				mobileNumber: null,
				emailId: null,
				tags: [],
			});

			const multiSelectState = reactive({
				leadPriority: Data.leadPriority,
				leadStatus: Data.leadStatus,
				tripType: Data.tripType,
				enquiryType: Data.enquiryType,
				users: [],
				usersSelect: [],
				tags: [],
				tagsSelect: [],
				filterQuery: "",
				limit: 10,
				limitSelect: [5, 10, 15, 20, 25, 30, 35, 40, 50, 60, 80, 100, 150, 200],
			});

			const formState = reactive({
				enabled: false,
			});

			const checkSlug = () => {
				let slugQuery = null;
				if (props.slug && ["Hot", "Warm", "Cold"].includes(props.slug) &&  !filter.enabled) {
					slugQuery = `&leadPriority=${props.slug}&`;
				} else if (props.slug && ["Active", "New", "Booked", "Lost"].includes(props.slug) && !filter.enabled) {
					slugQuery = `&leadStatus=${props.slug}&`;
				}

				if (store.state.user.role[0] === process.env.VUE_APP_USER_SERVICE_EXECUTIVE) {
					slugQuery = "&leadPriority=Booked&"
				}

				return slugQuery;
			}

			const getLeads = async () => {
				try {
					let slugQuery = checkSlug();
					
					const { data } = await API.privateRequest.get(`leads?sort=desc${slugQuery ?? ''}`);
					if (!data.data.length) return;
					masterStore.methods.changeData(data.data);
					table.rows = masterStore.state.data;
					table.totalRecordCount = data?.count;
					table.isLoading = false;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};

			const sendMail = async (id, type = "proposal") => {
				try {
					await API.privateRequest.get(`/pdf?id=${id}&type=${type}`);
					toast.success(`${type} Mail Submitted !`);
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}
					toast.error(message, true);
				}

			};

			const sendWhatsApp = async (id, type = "proposal") => {
				try {

					await API.privateRequest.get(`send-template?id=${id}&type=${type}`);
					toast.success(`${type} Message submitted successfully !`);

				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}
					toast.error(message, true);
				}
			}

			const getFiles = async (id, type="proposal") => {
				try {
					let htmlFile = await API.privateRequest.get(`downloadPdf?id=${id}&type=${type}`);
					let fileBlob = new Blob([htmlFile.data], { type: "text/html"});
					const blobUrl = window.URL.createObjectURL(fileBlob);
					const link = document.createElement("a");
					
					link.href = blobUrl;
					link.setAttribute("target", "_blank");
					link.setAttribute("rel", "noopener noreferrer nofollow")
					link.setAttribute("style", "visibility:hidden;")
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					window.URL.revokeObjectURL(blobUrl);
				
				} catch (err) {
					console.log("error ->", err);

					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}
					toast.error(message, true);
				}
			};

			const doSearch = async (
				offset = null,
				limit = null,
				order = null,
				sort = null,
			) => {
				try {
					table.isLoading = true;

					let url = "";

					if (filter.enabled && multiSelectState.filterQuery) {
						url = `${url}${multiSelectState.filterQuery}`;
					}

					if (offset) url = `${url}offset=${offset}&`;
					if (limit) url = `${url}limit=${limit}&`;
					if (order) url = `${url}order=${order}&`;
					if (sort) url = `${url}sort=${sort}`;

					const slugQuery = checkSlug();

					const response = await API.privateRequest.get(`leads?${url}${slugQuery ?? ''}`);

					table.rows = response?.data.data;
					table.totalRecordCount = response?.data?.count;
					table.sortable.order = order;
					table.sortable.sort = "desc";
					table.isLoading = false;
				} catch (err) {
					alert(err);
				}
			};

			const tableLoadingFinish = (elements) => {
				// console.log(document.querySelector(".quick-btn"));
				table.isLoading = false;

				Array.prototype.forEach.call(elements, function (element) {
				
					if (element.classList.contains("action-btn")) {
						element.addEventListener("click", function () {
							decideAction(this.dataset.id, this.dataset.action);
						});
					}

				});
			};
			const decideAction = (id, action) => {
				id = id.trim();
				action = action.trim();
				try {
					if (action === "delete") {
						masterStore.methods.setId("delete", id);
						table.rows = table.rows.filter((row) => row._id !== id);
					} else if (action === "show") {
						masterStore.methods.changeComponent("view");
						masterStore.methods.changeData(
							table.rows.filter((row) => row._id === id)[0],
						);
					} else if (action === "edit") {
						masterStore.methods.setId("edit", id);
						masterStore.methods.changeData(
							table.rows.filter((row) => row._id === id)[0],
						);
						masterStore.methods.changeComponent("edit");
					} else if (action === "email") {
						sendMail(id, "proposal");
					} else if (action === "whatsapp") {
						sendWhatsApp(id, "proposal");
					} else if (action === "note") {
						toggleModel();
						model.id = id;
					} else if (action === "receipt") {
						masterStore.methods.changeData(
							table.rows.filter((row) => row._id === id)[0],
						);
						masterStore.methods.changeComponent("payment");
					} else if (action === "send-receipt") {
						sendMail(id, "receipt");
					} else if (action === "preview-email") {
						getFiles(id);
					} else if (action === "preview-receipt") {
						getFiles(id, "receipt");
					}
				} catch (err) {
					console.log("error in UserTable actions");
				}
			};

			const updateLead = async (dataObj) => {
				try {
					let data = { ...dataObj };

					delete data.id;

					await API.privateRequest.patch(`/leads/${dataObj.id}`, data);

					if (model.active) toggleModel();

					toast.success(`note updated !`);

					model.note = null;
				} catch (err) {
					if (model.active) toggleModel();

					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};

			const toggleModel = () => (model.active = !model.active);
			const modelEvent = (eventText) => {
				if (eventText === 'save') updateLead({ id: model.id, notes: model.note });
				else toggleModel();
			};

			//! filters start

			const getUsers = async () => {
				try {
					const users = await API.privateRequest.get("/users?filter=1");
					multiSelectState.users = users.data.data;
					multiSelectState.usersSelect = users.data.data.map((item) => {
						return {
							value: item._id,
							label: `${item.firstName} ${item.lastName}`,
						};
					});
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};

			const getTags = async () => {
				try {
					const response = await API.privateRequest.get("tags");
					const changedTags = response.data.data.map((tag) => ({
						value: tag._id,
						label: tag.name,
					}));
					multiSelectState.tags = response.data.data;
					multiSelectState.tagsSelect = changedTags;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};

			const removeFilter = reactive({
				user: false,

			})
			
			if (["SALES_EXECUTIVE", "SR_SALES_EXECUTIVE","MANAGEMENT_TRAINEE"].includes(store.state.user.role[0])) {
				removeFilter.user = true;
			} else {
				getUsers();
			}

			getTags();

			const setLeadPriority = (dataObj) => {
				filter.leadPriority = dataObj;
			};

			const setLeadStatus = (dataString) => {
				filter.leadStatus = dataString;
			};

			const setAssignedTo = (dataObj) => {
				filter.assignedTo = dataObj;
			};
			const setEnquiryType = (dataObj) => {
				filter.enquiryType = dataObj;
			};

			const setTags = (dataObj) => {
				filter.tags = dataObj;
			};

			const setFilterQuery = () => {
				let queryString = "";
				let keys = Object.keys(filter);
				keys = keys.filter((key) => key !== "enabled");
				keys = keys.filter((key) => {
					
					if (filter[key] instanceof Array && !filter[key].length) {
						return null
					} else if (filter[key]) return key 
					else return null
			
				});
				keys.map((key, index) =>
					index === 0
						? (queryString = `${key}=${filter[key]}&`)
						: (queryString = `${queryString}&${key}=${filter[key]}&`),
				);

				if (!filter.tags.length) {
					queryString = queryString.replace("tags=", "");
				}

				multiSelectState.filterQuery = queryString;
				doSearch(false, multiSelectState.limit, "desc");
			};

			const setLimit = (limit) => {
				multiSelectState.limit = limit;
			};


			onMounted(() => {
				
				getLeads();
				
				
			});

			return {
				model,
				table,
				masterStore,
				filter,
				removeFilter,
				formState,
				multiSelectState,
				doSearch,
				tableLoadingFinish,
				toggleModel,
				modelEvent,

				setLeadPriority,
				setLeadStatus,
				setAssignedTo,
				setEnquiryType,
				setTags,
				setFilterQuery,
				setLimit,
			};
		},
	};
</script>
<style scoped>
.table-wrapper {
	background: rgb(0 172 223 / 9%);
	box-shadow: none;
}
	::v-deep(.vtl-paging-info) {
		font-size: 0.8rem;
		
	}
	::v-deep(.vtl-paging-count-label),
	::v-deep(.vtl-paging-page-label) {
		padding-left: 1rem;
		padding-right: 0.4rem;
		font-size: 0.8rem;
	}
	::v-deep(.vtl-paging-pagination-div) {
		padding-bottom: 1rem;
		font-size: 0.8rem;
	}
	::v-deep(.vtl-tbody),
	::v-deep(.vtl-thead-th) {
		font-size: 0.8rem;
		color: #898989;
		background: transparent;
	}
	::v-deep(.vtl-thead-column) {
		color: #00A0E3;
		background: transparent;
	}

	::v-deep(.vtl-tbody-td > div) {
		height: 100%;
	}

	::v-deep(.vtl-tbody-tr .vtl-tbody-td) {
		border: none;
	}
	::v-deep(.vtl-thead-tr) {
		border-bottom: 1px solid #00A0E3;
	}
	::v-deep(.vtl-thead-tr .vtl-thead-th) {
		background: none;
		color: #000;
		border: none;
	}
	::v-deep(.vtl-card) {
		padding: 0;
		border-radius: 20px;
		background: transparent;
	}
	::v-deep(.vtl-paging) {
		padding: 0 1rem;
	}
	.vtl-thead-td::nth-child(5) {
		background: red;
	}
	::v-deep(.action-dot) {
		height: 8px;
		width: 8px;
		border-radius: 50%;
		background: #3DAB72;
		position: relative;
	}
	::v-deep(.action-dot::before) {
		content: "";
		position: absolute;
		left: -120%;
		height: inherit;
		width: inherit;
		border-radius: inherit;
		background: #00A0E3;
		z-index: 0;
	}
	::v-deep(.action-dot::after) {
		content: "";
		position: absolute;
		right: -120%;
		height: inherit;
		width: inherit;
		border-radius: inherit;
		background: #F4BB22;
		z-index: 0;
	}
	::v-deep(.actions) {
		display: none;
		flex-direction: column;
		justify-content: space-between;
		position: absolute;
		border-radius: 10px;
		box-shadow: rgb(9 30 66 / 25%) 0px 4px 8px -2px, rgb(9 30 66 / 8%) 0px 0px 0px 1px;
		background: #fff;
		height: auto;
		z-index: 9999;
		top: -20px;
		left: -100%;
		min-width: 200px;
		padding: 0.6rem 1rem;
		transition: 0.8s ease-in-out;
	}
	::v-deep(.action-btn:hover) {
		color: #fff !important;
		background: #00A0E3;
	}
	/* ::v-deep(.actions:after) {
		content: "";
		top: 50%;
		right: 50%;
		transform: translateY(-50%) rotateZ(45deg);
		height: 20px;
		width: 20px;
		background: inherit;
	} */
	::v-deep(.action-container) {
		height: 100%;
		cursor: pointer;
		transition: 0.8s ease-in-out;
	}
	::v-deep(.action-container:hover .actions) {
		display: flex;
		transition: 0.8s ease-in-out;
	}

	/* we will explain what these classes do next! */
	.v-enter-active,
	.v-leave-active {
		transform-origin: 1.8rem 0;
		transition: transform 0.5s ease-in-out;
	}

	.v-enter-from,
	.v-leave-to {
		transform: scale(0);
		transform-origin: 1.8rem 0;
	}
	.filter-row {
		background: #fff;
	}
	::v-deep(.action-btn) {
		border-radius: 8px;
		padding: 4px 6px;
	}
	::v-deep(.custom-rounded)
	{
		border-radius: 25px !important;
	}
	::v-deep(.vtl-table)
	{
		overflow: visible;
	}
	::v-deep(.vtl-thead){
		text-align: center;
	}
	::v-deep(.flash-status) {
		animation: grow 2s ease-in-out infinite;
	}
	.form-check-input{
		border: 1px solid #F4BB22;
	}
	@keyframes grow {
		from {
			transform: scale(.9);
		}
		to {
			transform: scale(1);
		}
	}
</style>
